import { css } from 'linaria';

export const creditBlockModalTitle = css`
  && {
    @media (--only-mobile) {
      text-align: center;
      font-size: 18px;
      line-height: 24px;
    }
  } 
`;

export const creditBlockModalText = css`
  margin-bottom: 8px;

  @media (--only-mobile) {
    margin-bottom: 4px;
  }
`;

export const creditBlockModalTextList = css`
  margin: 0 0 8px 0;
  padding: 0;
  list-style: none;
`;

export const creditBlockModalTextLink = css`
  text-decoration: none;
  display: inline-block;
  color: var(--control-accent);

  &:focus {
    text-decoration: none;
    color: var(--control-hover-accent)
  }

  &:hover {
    text-decoration: none;
    color: var(--control-hover-accent)
  }
`;

export const creditBlockModalBtn = css`
  width: 100%;
`;